"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportCreatePayloadSchema = exports.ImportListDtoSchema = exports.ImportDtoSchema = void 0;
const zod_1 = require("zod");
exports.ImportDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    asset_id: zod_1.z.number(),
    dataset_id: zod_1.z.number(),
    dataset: zod_1.z.object({
        id: zod_1.z.number(),
        slug: zod_1.z.string(),
    }),
    user_id: zod_1.z.number(),
    status: zod_1.z.union([
        zod_1.z.literal('pending_data'),
        zod_1.z.literal('processing'),
        zod_1.z.literal('uploaded'),
        zod_1.z.literal('error'),
    ]),
    error: zod_1.z.unknown(),
    created_at: zod_1.z.date({ coerce: true }),
    updated_at: zod_1.z.date({ coerce: true }),
});
exports.ImportListDtoSchema = zod_1.z.object({
    data: zod_1.z.array(exports.ImportDtoSchema),
});
exports.ImportCreatePayloadSchema = zod_1.z.object({
    asset: zod_1.z.number().optional(),
    dataset: zod_1.z.number(),
    data: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.unknown())),
});
//# sourceMappingURL=importSchema.js.map